export default __webpack_public_path__ + "static/media/two-countries-background.780e442c.jpg";